import React from 'react';
import getStyles from './styles';
import { ProjectViewPage } from '../../../components';

const TanfundPage = () => {
  const styles = getStyles();
  return (
    <ProjectViewPage
      // heroTitle="A Feature-Rich App Built for"
      // heroGradientText="Networking and Navigation"
      infoLabel1="Client"
      infoLabel2="Services"
      infoLabel3="Deliverables"
      infoLabel4="Tech Stack"
      client="StartupTN TANFUND"
      services={['UX/UI Design', 'Full Stack Development']}
      deliverables={['Mobile Application', 'CMS Dashboard']}
      techStack={['React Native', 'Node.js', 'Express']}
      clientLogo="/images/startup-white.png"
      overviewTitle="Overview"
      // approachTitle="Approach"
      infoLabel5="Website"
      visitWebsite="Visit Site"
      website="https://www.tanfund.in/"
      heroImage="/images/tanfund-first.png"
      overviewImage="/images/tanfund-first.png"
      approachImage="/images/tanfund-full.jpeg"
      overviewDescription={[
        'TANFUND is a premier fund aggregation platform promoted by StartupTN, the nodal agency of the Government of Tamil Nadu for innovation and entrepreneurship. The portal serves as a bridge between innovative startups and a wide network of funding partners, connecting Tamil Nadu’s emerging ventures with reputed global and domestic investors. Designed to streamline access to capital, TANFUND helps startups across diverse sectors such as technology, manufacturing, healthcare, fintech, and sustainability to discover suitable funding opportunities and accelerate their growth.'
      ]}
      approachDescription={[
        'Through its data-driven matchmaking system, TANFUND aligns startups with the most relevant funding avenues based on their stage, capital requirements, and business goals. The platform provides direct access to venture capitalists, private equity firms, angel networks, and government investment agencies, enabling founders to engage with investors who are actively seeking to support Tamil Nadu-based ventures. In addition, TANFUND enhances visibility within investor communities through curated networking events, demo sessions, and partnership programs, giving startups the recognition and exposure they deserve.',
        'TANFUND’s ecosystem includes a broad spectrum of funding partners such as venture debt firms, family offices, revenue-based financiers, accelerators, and government agencies that offer both financial and strategic support. By consolidating these opportunities in one place, TANFUND acts as a strategic growth enabler for Tamil Nadu’s startup landscape. It not only facilitates funding but also builds a foundation of mentorship, collaboration, and long-term sustainability—empowering startups to scale with confidence and contribute to the state’s innovation-driven economy.'
      ]}
      heroContainerStyle={styles.container}
      commonSectionStyle={styles.section}
      heroSectionStyle={styles.heroSection}
      heroGradientStyle={styles.heroGradient}
      heroGlow1Style={styles.heroGlow1}
      heroGlow2Style={styles.heroGlow2}
      heroGlow3Style={styles.heroGlow3}
      containerWrapperStyle={styles.containerWrapper}
      heroImageContainerStyle={styles.heroImageContainer}
      phoneContainerStyle={styles.phoneContainer}
      phoneGlowStyle={styles.phoneGlow}
      phoneShadowStyle={styles.phoneShadow}
      heroPhoneStyle={styles.heroPhone}
      heroContentStyle={styles.heroContent}
      heroTitleStyle={styles.heroTitle}
      gradientTextStyle={styles.gradientText}
      infoCardStyle={styles.infoCard}
      infoItemStyle={styles.infoItem}
      infoLabelStyle={styles.infoLabel}
      primaryBadgeStyle={styles.primaryBadge}
      secondaryBadgeStyle={styles.secondaryBadge}
      badgesContainerStyle={styles.badgesContainer}
      accentBadgeStyle={styles.accentBadge}
      outlineBadgeStyle={styles.outlineBadge}
      overviewSectionStyle={styles.overviewSection}
      overviewGradientStyle={styles.overviewGradient}
      overviewGlowStyle={styles.overviewGlow}
      overviewGridStyle={styles.overviewGrid}
      overviewContentStyle={styles.overviewContent}
      sectionHeaderStyle={styles.sectionHeader}
      accentLineStyle={styles.accentLine}
      sectionTitleStyle={styles.sectionTitle}
      textContainerStyle={styles.textContainer}
      sectionTextStyle={styles.sectionText}
      overviewImageContainerStyle={styles.overviewImageContainer}
      overviewImageWrapperStyle={styles.overviewImageWrapper}
      overviewImageGlowStyle={styles.overviewImageGlow}
      overviewImageStyle={styles.overviewImage}
      approachSectionStyle={styles.approachSection}
      approachGradientStyle={styles.approachGradient}
      approachGlow1Style={styles.approachGlow1}
      approachGlow2Style={styles.approachGlow2}
      approachGridStyle={styles.approachGrid}
      approachContentStyle={styles.approachContent}
      // approachAccentLineStyle={styles.approachAccentLine}
      approachTitleStyle={styles.approachTitle}
      approachTextStyle={styles.approachText}
      scrollAreaStyle={styles.scrollArea}
      scrollContentStyle={styles.scrollContent}
      approachImageWrapperStyle={styles.approachImageWrapper}
      approachImageGlowStyle={styles.approachImageGlow}
      approachImageStyle={styles.approachImage}
    />
  );
};

export default TanfundPage;
